export default "__VITE_ASSET__LISqMjpm__"